import { Component } from '@angular/core';
import { environment } from '../../environments/environment';
import { TaasButtonComponent } from "utimaco-common-ui-angular";

@Component({
  selector: 'app-registration-success',
  standalone: true,
  imports: [TaasButtonComponent],
  templateUrl: './registration-success.component.html',
  styleUrl: './registration-success.component.scss'
})
export class RegistrationSuccessComponent {

  goToHomepage(){
    window.open(environment.homeLink, '_self');
  }
}
